import React, { Component } from 'react';
import 'normalize.css';
import 'draft-js/dist/Draft.css'; 
import 'semantic-ui-css/semantic.min.css'; 
import './content/css/site.css';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import 'react-day-picker/lib/style.css';
import 'moment/locale/es';

import { isauthenticated } from './_helpers/is-authenticated';

import Header from './_components/layout/Header';
import Content from './_components/layout/Content.js';

class App extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const isAuth = isauthenticated();
    return (
      <div className="container">
      <ToastContainer />
      { isAuth &&
        <Header />
      }
        <main className="page_wrap">
          <Content />
        </main>
      </div>
    );
  }
}

export default App;
